<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<el-page-header @back="goBack" :content="from.name">
		</el-page-header>
		<!-- 表格 -->
		<div class="mt-3 " style="padding-bottom:20px">
			 <el-tabs v-model="activeName" >
			    <el-tab-pane :label="$t('cdnd.nav1')" name="1">
					<el-card class="box-card">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info')}}</span>
					
						  </div>
					  <el-descriptions  :column="2">
					      <el-descriptions-item :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
					      <el-descriptions-item :label="$t('status.status')">
							  <span style="color: #999;" v-if="info.status==2">{{$t('cdn.status2')}}</span>
							  <span class="text-success" v-if="info.status==1">{{$t('cdn.status1')}}</span>
							  <span class="text-danger" v-if="info.status==0">{{$t('cdn.status0')}}</span>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.cname')">
							  <div v-if="info.get_status==0 || info.get_status==1">
							  	<span style="color: #999;">{{$t('cdn.status2')}}</span>
							  	<span @click="checkCnameDetail(info)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="info.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
							  </div>
							  
							  <div v-else >
							  	<span class="mb-4">{{ info.cname }}</span>
							  	
							  	
							  	<span class="iconCopy" @click="copyText(info.cname)"><i class="iconfont icon-fuzhi"></i></span>
							  </div>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.business_type')">
								<span v-if="info.business_type==1">{{$t('cdn.business_type1')}}</span>
								<span v-if="info.business_type==2">{{$t('cdn.business_type2')}}</span>
								<span v-if="info.business_type==3">{{$t('cdn.business_type3')}}</span>
								<span v-if="info.business_type==4">{{$t('cdn.business_type4')}}</span>
					      </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdnd.https')">
							  <span v-if="info.ssl_status==1">{{$t('cdnd.open')}}</span>
							  <span v-if="info.ssl_status==0">{{$t('cdnd.close')}}</span>
						  </el-descriptions-item>
						  <el-descriptions-item :label="$t('cdn.product')">
							  <span>{{info.pro_name}}</span>
						  </el-descriptions-item>
						  
						  <el-descriptions-item :label="$t('cdn.remark')">
						  		<span>{{info.remark}}</span>
						  </el-descriptions-item> 
						  <el-descriptions-item :label="$t('adminList.createTime')">
						  		<span>{{info.create_time}}</span>
						  </el-descriptions-item>
					  </el-descriptions>
					</el-card>
					
					
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdn.source')}}</span>
							<el-button @click="openModel(false)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.add')}}</el-button>
						  </div>
					  
					   <el-table
					        :data="info.source"
					        style="width: 100%">
					        <el-table-column align="center" prop="url" :label="$t('cdn.source')">
					        </el-table-column>
					        <el-table-column align="center" prop="type" :label="$t('cdn.source_type')">
								<template slot-scope="scope">
									<span  v-if="scope.row.type==1">{{$t('cdn.source_type1')}}</span>
									<span  v-if="scope.row.type==2">{{$t('cdn.source_type2')}}</span>
									
								</template>
					        </el-table-column>
					        <el-table-column align="center"  :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										
										<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
										
									
										
										<el-button   size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteSource(scope.row)">{{$t('cdn.del')}}</el-button>
										
										
									</el-button-group>
								</template>
					        </el-table-column>
					      </el-table>
					</el-card>
					
				</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav2')" name="2">
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.range')}}</span>
							
						  </div>
						<div>
							<div>{{$t('cdnd.range1')}}</div>
							<div class="text_chengse mb-2 mt-2">{{$t('cdnd.range2')}}</div>
							<el-switch
							@change="changeRnage"
							  v-model="rangeStatus"
							  active-color="#13ce66"
							  inactive-color="#999999">
							</el-switch>
						</div>
					   
					</el-card>
				</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav3')" name="3">
					
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.nav3')}}</span>
							
						  </div>
						<div>
							<div class="mb-3">{{$t('cdnd.info1')}}</div>
							
							<el-button  class="mb-2" size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('cdnd.add')}}</el-button>
							<el-table
							     :data="info.cert"
							     style="width: 100%">
							     <el-table-column align="center" prop="name" :label="$t('cdnd.cert_name')">
							     </el-table-column>
								 
							     <el-table-column align="center" prop="type" :label="$t('cdnd.cert_from')">
								<template slot-scope="scope">
									<span  v-if="scope.row.type==1">{{$t('cdnd.cert_from1')}}</span>
									<span  v-if="scope.row.type==2">{{$t('cdnd.cert_from2')}}</span>
									
								</template>
	 </el-table-column>
	 <el-table-column align="center" prop="end_time" :label="$t('cdnd.end')">
	 </el-table-column>
	 <el-table-column align="center"  :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										
										<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
										
									
										
										<el-button   size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteSource(scope.row)">{{$t('cdn.del')}}</el-button>
										
										
									</el-button-group>
								</template>
							     </el-table-column>
							   </el-table>
						</div>
					   
					</el-card>
					
					
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info2')}}</span>
							
						  </div>
						<div>
							<div class="mb-3">{{$t('cdnd.info3')}}</div>
							
							<span class="mr-2">{{$t('cdnd.info4')}}</span>
							<el-switch
							@change="changeSSL"
							  v-model="ssl_status"
							  active-color="#13ce66"
							  inactive-color="#999999">
							</el-switch>
						</div>
					   
					</el-card>
				</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav4')" name="4">缓存配置</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav5')" name="5">分组配置</el-tab-pane>
			  </el-tabs>
		</div>



		

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('cdnd.editSource') : $t('cdnd.addSource')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('cdn.source')" prop="url">
					<el-input  @input="handleSourceInput"  v-model="form.url" :type="editIndex > -1?'text':'textarea'" :rows="8"  :placeholder="form.source_type==1?$t('cdn.source_tis_1'):$t('cdn.source_tis_2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				activeName:"1",
				createModel: false,
				editIndex: -1,
				info:{},
				rangeStatus:0,
				ssl_status:0,
				//搜索數据
				from: {
					id:0,
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/domainDetail", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/addSource", //删除單条地址
				addUrl: "data/addSource", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					url: [{
						required: true,
						message: this.$t('cdn.inpSource'),
						trigger: 'blur'
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			//this.commonList('account');
			
			if(localStorage.getItem('domainDetail')){
				let domainDetail = JSON.parse(localStorage.getItem('domainDetail'));
				this.from.name = domainDetail.domain_name
				this.from.id = domainDetail.id
				//console.log(domainDetail)
			}else{
				this.goBack()
			}
		},
		methods: {
			
			goBack(){
				localStorage.setItem('domainDetail', '');
				this.$router.push({
					name: 'cdn_domain',
					params:{}
				})
			},
			handleSourceInput(val) {
				let num = 50 - parseInt(this.info.count)
				console.log(num)
			    const lines = val.split('\n');
			    if (lines.length > num) {
			      this.form.url = lines.slice(0, num).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('cdn.limitSource'));
			    }
			  },
			  changeRnage(e){
				  let val = this.rangeStatus?1:0
				  this.editDomain('range_status',val)
			  },
			  changeSSL(e){
				  let val = this.ssl_status?1:0
				  this.editDomain('ssl_status',val)
			  },
			  editDomain(type,val){
				  this.layout.loading = true;
				  this.axios.post('/admin/data/editDomain', {
				  	type: type,
				  	val: val,
				  	id:this.info.id
				  }, {
				  	token: true,
				  }).then(res => {
				  	let all = res.data
				  	let list = all.data.list
					console.log(list)
				  	
				  	this.layout.loading = false;
				  }).catch(err => {
				  	// 失敗
					if(type=='range_status'){
						this.rangeStatus = this.rangeStatus==1?0:1
					}
					
					if(type=='ssl_status'){
						this.ssl_status = this.ssl_status==1?0:1
					}
					
				  	this.layout.loading = false;
				  })
				  //console.log(this.rangeStatus)
			  },
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			
			deleteSource(item) {
				let index = this.info.source.findIndex(item=>item.url == item.url)
				this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.delete'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post(this.deleteUrl(), {
						cid: this.info.id,
						index:index,
						type:3
					}, {
						token: true
					}).then(res => {
						let all = res.data;
						if (all.code == 1) {
							this.$message({
								message: this.$t('system.deleteSuccess'),
								type: 'success'
							});
							this.getList()
						}
						
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			checkCnameDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkCnameDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.get_status = list.get_status
					item.status = list.status
					item.cname = list.cname
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				//console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						cid:this.info.id,
						index:0,
						type:1,
						url: '',
						
						
					}
					this.editIndex = -1
				} else {
					let index = this.info.source.findIndex(item=>item.url == e.url)
					//console.log(index)
					// 修改
					this.form = {
						cid:this.info.id,
						id:this.info.id,
						url: e.url,
						index:index,
						type:2
						
					}
					this.editIndex = this.info.id
					console.log(this.editIndex)
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='account'){
						this.agentData.cloud = list.cloud
						this.agentData.product = list.product
						this.agentData.sup = list.sup
						this.odds = list.user_odds
					}else{
						console.log(list)
						console.log(id)
						this.agentData.account = list.account
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.info = e.info
				console.log(e)
				this.rangeStatus = this.info.range_status
				this.ssl_status = this.info.ssl_status
				// this.check_img_list = e.list.map(item=>{
				// 	return item.head
				// })
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style >
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.el-descriptions-item__container {
    display: flex;
    align-items: flex-end;
	height: 30px;
}

.body_head{
	font-weight: bold;
	font-size: 15px;
}
</style>
